import { Currency } from './currency';
import { WorkSchedule } from './work-schedule';

export class Organization {
  id: number;
  name: string;
  industry: string | null;
  country: string | null;
  timezone: string | null;
  currency: Currency | null;
  services: string[] | null;
  workSchedule: WorkSchedule | null;

  constructor(
    id: number,
    name: string,
    industry: string | null,
    country: string | null,
    timezone: string | null,
    currency: Currency | null,
    services: string[] | null,
    workSchedule: WorkSchedule | null
  ) {
    this.id = id;
    this.name = name;
    this.industry = industry;
    this.country = country;
    this.timezone = timezone;
    this.currency = currency;
    this.services = services;
    this.workSchedule = workSchedule;
  }

  static fromResponse(data: any): Organization {
    return new Organization(
      data.id,
      data.name,
      data.industry || null,
      data.country || null,
      data.timezone || null,
      data.currency ? new Currency(data.currency.code, data.currency.displayName) : null,
      data.services || null,
      data.workSchedule ? WorkSchedule.fromResponse(data.workSchedule) : null
    );
  }
}

export class OrganizationUpdateRequest {
  name: string;
  industry: string | null;
  country: string | null;
  timezone: string | null;
  defaultCurrencyCode: string | null;
  services: string[] | null;
  workSchedule: WorkSchedule;

  constructor(
    name: string,
    industry: string | null,
    country: string | null,
    timezone: string | null,
    defaultCurrencyCode: string | null,
    services: string[] | null,
    workSchedule: WorkSchedule
  ) {
    this.name = name;
    this.industry = industry;
    this.country = country;
    this.timezone = timezone;
    this.defaultCurrencyCode = defaultCurrencyCode;
    this.services = services || [];
    this.workSchedule = workSchedule;
  }
}
